import { Component, inject, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { DecisionModalComponent } from '../decision-modal/decision-modal.component';
import { Decision } from '../../../../shared/models/internal/decision';
import { UnsavedChangesTrackerService } from '../../../services/unsaved-changes-tracker.service';
import { DecisionLevel } from '../../../../shared/enums/decision-level';
import { UnsavedChangesRequest } from '../../../../shared/models/internal/modals/unsaved-changes-request';

@Component({
  selector: 'app-unsaved-changes-modal',
  imports: [DecisionModalComponent],
  templateUrl: './unsaved-changes-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './unsaved-changes-modal.component.scss',
})
export class UnsavedChangesModalComponent implements OnInit {
  @Input() public header = '';
  @ViewChild('unsavedChangesModale8732te82j') public unsavedChangesModal?: DecisionModalComponent;

  public decisionLevel = DecisionLevel.Warning;
  public decicionButtons = [
    { text: 'Stay', value: 'stay' },
    { text: 'Leave', value: 'leave' },
  ];

  private unsavedChangesService = inject(UnsavedChangesTrackerService);
  private executeOnLeave?: () => void;
  private excecuteOnStay?: () => void;

  public ngOnInit(): void {
    this.unsavedChangesService.unsavedChanges$.subscribe((hasUnsavedChanges: boolean) => {
      if (hasUnsavedChanges) {
        this.openModal();
      }
    });

    this.unsavedChangesService.modalRequest$.subscribe((req: UnsavedChangesRequest) => {
      this.openModal(req);
    });
  }

  public openModal(request?: UnsavedChangesRequest): void {
    if (this.unsavedChangesModal) {
      this.unsavedChangesModal.header = request?.title ?? this.header;
      this.executeOnLeave = request?.onLeave;
      this.excecuteOnStay = request?.onStay;
      this.unsavedChangesModal.openModal();
    }
  }

  public onUnsavedChangesConfirmed(decision: Decision): void {
    if (decision.result && decision.value === 'stay') {
      if (this.excecuteOnStay) {
        this.excecuteOnStay();
      }
    } else if (decision.result && decision.value === 'leave') {
      this.unsavedChangesService.clearAllUnsavedChanges();

      if (this.executeOnLeave) {
        this.executeOnLeave();
      }
    }
  }
}
